module.exports = __webpack_public_path__ + "static/media/ultraviolet.75a9865f.svg";